import React from 'react';
import '../../styles/Home.css';

const handleScroll = () => {
  const target = document.getElementById('our-brands');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' }); // podés usar 'auto' si necesitás
  }
};


const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className='row align-items-end justify-content-center text-center'>
        <div className='col-12'>
          <img src="https://www.behealthpr.com/wp-content/uploads/2025/02/logo-Behealth-blanco.png" className='img-fluid' alt="logo behealth"  data-aos="fade-up" data-aos-delay="400"/>
        </div>
        <div className='col-12'>
          <div>
            <h2 data-aos="fade-up" data-aos-delay="400">2026</h2>

          </div>
        </div>
        <div className='col-12'>
          <a onClick={handleScroll} >
            <svg className="scroll-down-icon" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#2dab64" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
